import { useNavigate } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Button,
  IconButton,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import AddLabel from "../../Modals/addLabel";
import DeleteConfirmModal from "../../Modals/deleteConfirmModal";
import { useLazyGetLabelQuery, useDeleteLabelMutation } from "../../services/label";
import { isValidInput } from "../../utils/validations";
import { showError, showToast } from "../../constants/toasts";
import IfCan from "../../components/IfCan";

const LabelRecognition = () => {
  const navigate = useNavigate();

  

  const columns = [
    { id: "label", label: "Label Name" },
    { id: "actions", label: "Actions" },
  ];

  const [searchTerm, setSearchTerm] = useState("");

  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const handleCloseModal = () => {
    setOpen(false);
    setIsEdit(false);
    setSelectedId(null);
  };

  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [getLabel] = useLazyGetLabelQuery();
  const [deleteLabel] = useDeleteLabelMutation();

  const getlabelList = async () => {
    setIsLoading(true);
    try {
      const response = await getLabel({
        search: debouncedSearchTerm,
      }).unwrap();
      if (response?.status === 200) {
        setData(response?.data || []);
        setTotalCount(Array.isArray(response?.data) ? response.data.length : 0);
      } else {
        setData([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.log(error);
      setData([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getlabelList();
  }, [debouncedSearchTerm]);

  const handleEdit = (id: number) => {
    setSelectedId(id);
    setIsEdit(true);
    setOpen(true);
  };

  const handleDelete = async () => {
    if (!selectedId) return;
    try {
      await deleteLabel({ id: selectedId }).unwrap();
      showToast("Label deleted successfully");
      getlabelList();
    } catch (e: any) {
      showError(e?.data?.message || "Failed to delete label");
    }
    setDeleteOpen(false);
    setSelectedId(null);
  };

  

  return (
    <>
      <>
        <div className="main_title">
          <h1>Label Recognition Editor</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Label Recognition Editor
          </p>
        </div>

        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  placeholder="Search..."
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <IfCan module="Label Recognition" action="add_edit">
              <div className="right_s">
                <Button className="btn btn_primary" onClick={() => { setIsEdit(false); setSelectedId(null); setOpen(true); }}>
                  <AddIcon /> Add{" "}
                </Button>
              </div>
            </IfCan>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  {columns.map((col) => (
                    <TableCell key={col.id}>{col.label}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{row.label_name}</TableCell>

                    <TableCell>
                      <div className="table_actions v2">
                        <IfCan module="Label Recognition" action="add_edit">
                          <Box>
                            <IconButton onClick={() => handleEdit(row.id)}>
                              <img
                                src="/static/images/edit2_icon.svg"
                                alt="Edit"
                              />
                            </IconButton>
                          </Box>
                        </IfCan>
                        <IfCan module="Label Recognition" action="delete">
                          <Box>
                            <IconButton onClick={() => { setSelectedId(row.id); setDeleteOpen(true); }}>
                              <img
                                src="/static/images/trash2_icon.svg"
                                alt="Delete"
                              />
                            </IconButton>
                          </Box>
                        </IfCan>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </>
      <IfCan module="Label Recognition" action="add_edit">
        <AddLabel
          open={open}
          onClose={handleCloseModal}
          setOpen={setOpen}
          editId={selectedId ?? undefined}
          isEdit={isEdit}
          onSuccess={getlabelList}
        />
      </IfCan>
      <IfCan module="Label Recognition" action="delete">
        <DeleteConfirmModal
          open={deleteOpen}
          setOpen={setDeleteOpen}
          handleDelete={handleDelete}
          title="Are you sure you want to delete this label?"
          message="This action cannot be undone."
        />
      </IfCan>
    </>
  );
};

export default LabelRecognition;
